<template>
  <div>
    <router-view />
  </div>
</template>
<script>
  export default {
    data: () => ({
      show: false,
    }),
  }
</script>